import i18n from '@/i18n'
import { COMPANY_PAGE_TYPE } from '@/constant/company'
import JobList from './jobList.vue'
import JobDetail from './jobDetail/index.vue'
import { deviceType } from '@/utils/common'
import PCCompanyBranding from './companyBranding.vue'
import MobileCompanyBranding from '../mobile/companyBranding.vue'

const basePath = '/recruiting/company/:companyId'
const brandingRoute = {
  path: `${basePath}/${COMPANY_PAGE_TYPE.BRANDING}/:pageNum`,
  component: PCCompanyBranding,
  meta: {
    pageType: COMPANY_PAGE_TYPE.BRANDING
  }
}

const landingRoute = {
  path: `${basePath}/${COMPANY_PAGE_TYPE.LANDING}/:pageNum`,
  component: PCCompanyBranding,
  meta: {
    pageType: COMPANY_PAGE_TYPE.LANDING
  }
}

const jobListRoute = {
  path: `${basePath}/${COMPANY_PAGE_TYPE.JOB_LIST}`,
  component: JobList,
  meta: {
    pageType: COMPANY_PAGE_TYPE.JOB_LIST,
    title: i18n.t('company.title.jobList')
  }
}

const jobDetailRoute = {
  path: `${basePath}/job/:jobId/${COMPANY_PAGE_TYPE.JOB_DETAIL}`,
  component: JobDetail,
  meta: {
    pageType: COMPANY_PAGE_TYPE.JOB_DETAIL,
    title: i18n.t('company.title.jobDetail')
  }
}

export default [
  brandingRoute,
  landingRoute,
  {
    name: 'company-detail',
    path: '/recruiting/company-detail/:companyId',
    component: deviceType.isPc ? PCCompanyBranding : MobileCompanyBranding,
    meta: {
      noAuth: true,
      title: i18n.t('companyJobList.title'),
      pageType: COMPANY_PAGE_TYPE.BRANDING
    }
  },
  jobListRoute,
  jobDetailRoute
]

export { brandingRoute, landingRoute, jobListRoute, jobDetailRoute }
